<script setup>
/**
 * Imports
 */
import { onMounted } from "vue";
import { useWeatherStore } from "@/shared/stores/weather";
import { storeToRefs } from "pinia";

/**
 * Props, emits
 */

/**
 * Variables
 */
const { fetchWeather } = useWeatherStore();
const { weather } = storeToRefs(useWeatherStore());

/**
 * Computed
 */

/**
 * Methods
 */

/**
 * Hooks, watchers and calls
 */
onMounted(() => {
  fetchWeather();
});
</script>

<template>
  <div class="header__weather" v-if="weather">
    <IconComponent class="header__weather-icon" :name="weather.icon" />
    <div class="header__weather-info">
      <span class="header__weather-text">{{ weather.text }}</span>
      <span class="header__weather-temp">{{ weather.degrees }}°</span>
    </div>
  </div>
</template>

<style lang="stylus">
.header__weather {
  padding: 8px 16px
  border-radius 8px
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 2px 2px 0 var(--black-o05)
  width 220px

  &-info {
    display flex
    flex-direction column
  }

  &-text {
    color: var(--black-3)
    font-size: .875rem
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &-temp {
    font-size: .875rem
    line-height: 1.4
    color: var(--black-4)
  }

  &-icon {
    padding: 5px
    width: 34px;
    height: 34px;
    color: var(--yellow)
  }
}
</style>
